import LineItemFormTab from '@/Enums/CampaignManagement/LineItemFormTab.enum';

export const DV360_LINE_ITEM_TABS = [
  LineItemFormTab.Basic,
  LineItemFormTab.Geo,
  LineItemFormTab.Audience,
  LineItemFormTab.Daypart,
  LineItemFormTab.Creatives,
  LineItemFormTab.Summary,
];

export const DV360_DEFAULT_ACTIVE_TAB = LineItemFormTab.Basic;
